<div class="container-fluid mt-4">
  <form novalidate [formGroup]="padConstructionForm">
    <div class="row">
      <div class="col-md-8">
        @if (showDGWarning) {
          <h4 class="alert alert-warning">Warning: Allocated Wells are associated to multiple Drill Groups. Please verify that the correct Wells are allocated to this project.</h4>
        }
      </div>
      <div class="col-md-4">
        <button type="button" style="float: right;" kendoButton themeColor="primary" [buttonLoading]="loading" [svgIcon]="icons.refresh" [disabled]="loading" (click)="getPadConstructionParameters(true)">Refresh Parameters</button>
      </div>
    </div>
    <div class="row">
      <div class="flex-row flex-align-start flex-auto">
        <!-- Left Column -->
        <div class="flex-50">
          <div class="flex-column flex-align-center" style="padding-bottom:10px">
            <h6 class="card-title">Group Information</h6>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-15">
                <label>Well Count</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.WellCount}}">
              </div>
              <div class="form-group flex-15">
                <label>Drill Group Count</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.DrillGroupCount}}">
              </div>
              <div class="form-group flex-15">
                <label>Tank Battery Count</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.TankBatteryCount}}">
              </div>
              <div class="form-group flex-35">
                <label>Type Curve Area</label>
                <kendo-textbox formControlName="TypeCurveArea" [readonly]="true" class="form-control"></kendo-textbox>
              </div>
              <div class="form-group flex-20">
                <label>Construction Sub Type</label>
                <input type="text" class="k-textbox form-control" readonly value="{{constructionSubType}}">
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-15">
                <label>Reserve Pit ID</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.ReservePitId}}">
              </div>
              <div class="form-group flex-15">
                <label>Fresh Water Pit ID</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.FreshWaterPitId}}">
              </div>
              <div class="form-group flex-50">
                <label>Ultimate Pad Design</label>
                <input type="text" class="k-textbox form-control" formControlName="UltimatePadDesign">
              </div>
            </div>
          </div>

          <div class="flex-column flex-align-center" style="padding-bottom:10px">
            <h6 class="card-title">Pad & Surface Details</h6>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>
                  Proposed Pad Surface Area (Sq Ft)
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-2 inline-help-button" (click)="showEquation('ProposedPadAndAuxPadSurfaceArea')"></kendo-svgicon>
                </label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.ProposedPadAndAuxPadSurfaceArea}}">
              </div>
              <div class="form-group flex-50">
                <label>Tank Battery Surface Area</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.TankBatterySurfaceArea}}">
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>
                  Pad Cut Fill Volume (cu yds)
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-2 inline-help-button" (click)="showEquation('PadCutFillVolume')"></kendo-svgicon>
                </label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.PadCutFillVolume}}">
              </div>
              <div class="form-group flex-50">
                <label>Pad Cut Fill Volume Override (cu yds)</label>
                <kendo-numerictextbox formControlName="PadCutFillVolumeOverride" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>
                  Total Pad, TB & Aux Pad Surface Area (Sq Ft)
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-2 inline-help-button" (click)="showEquation('TotalPadSurfaceAreaAndTB')"></kendo-svgicon>
                </label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.TotalPadSurfaceAreaAndTB}}">
              </div>
              <div class="form-group flex-50">
                <label>Future Pad Surface Area (Sq Ft)</label>
                <kendo-numerictextbox formControlName="FuturePadSurfaceArea" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>
                  Aux Pad Surface Area (Sq Ft)
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-2 inline-help-button" (click)="showEquation('AuxPadSurfaceArea')"></kendo-svgicon>
                </label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.AuxPadSurfaceArea}}">
              </div>
              <div class="form-group flex-50">
                <label>Aux Pad Surface Area Override (Sq Ft)</label>
                <kendo-numerictextbox formControlName="AuxPadSurfaceAreaOverride" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>As-Built Pad Surface Area (Sq Ft)</label>
                <kendo-numerictextbox formControlName="AsBuiltPadSurfaceArea" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Truck in Fill Volume (cu yds)</label>
                <kendo-numerictextbox formControlName="TruckInFillVolume" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Pad Base Thickness (in)</label>
                <kendo-numerictextbox formControlName="PadBaseThickness" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Pad Width (ft)</label>
                <kendo-numerictextbox formControlName="PadWidth" class="form-control" [readonly]="true"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Pad Length (ft)</label>
                <kendo-numerictextbox formControlName="PadLength" class="form-control" [readonly]="true"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Pad Width Override (ft)</label>
                <kendo-numerictextbox formControlName="PadWidthOverride" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Pad Length Override (ft)</label>
                <kendo-numerictextbox formControlName="PadLengthOverride" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Total Rig Foundation Volume (cu yds)</label>
                <kendo-numerictextbox formControlName="TotalRigFoundationVolume" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Water Trucking / Spreading</label>
                <input type="text" class="k-textbox form-control" readonly value="{{padConstructionParameters?.WaterTruckingOrSpreading}}">
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Road Length 1 (ft)</label>
                <kendo-numerictextbox formControlName="RoadLength1" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Road Type 1</label>
                <kendo-dropdownlist class="form-control" formControlName="RoadTypeId1" [data]="dRoadType" [textField]="'Description'"
                  [valueField]="'RoadTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Road Length 2 (ft)</label>
                <kendo-numerictextbox formControlName="RoadLength2" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Road Type 2</label>
                <kendo-dropdownlist class="form-control" formControlName="RoadTypeId2" [data]="dRoadType" [textField]="'Description'"
                  [valueField]="'RoadTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Road Length 3 (ft)</label>
                <kendo-numerictextbox formControlName="RoadLength3" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Road Type 3</label>
                <kendo-dropdownlist class="form-control" formControlName="RoadTypeId3" [data]="dRoadType" [textField]="'Description'"
                  [valueField]="'RoadTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            @if (showTBFields) {
              <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
                <div class="form-group flex-50">
                  <label>TB Pad Width</label>
                  <kendo-numerictextbox formControlName="TBPadWidth" class="form-control" [readonly]="true"
                    [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                  </kendo-numerictextbox>
                </div>
                <div class="form-group flex-50">
                  <label>TB Pad Length</label>
                  <kendo-numerictextbox formControlName="TBPadLength" class="form-control" [readonly]="true"
                    [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                  </kendo-numerictextbox>
                </div>
              </div>
            }
            <!-- For each  Row  -->
            @if (showTBFields) {
              <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
                <div class="form-group flex-50">
                  <label>TB Pad Width Override</label>
                  <kendo-numerictextbox formControlName="TBPadWidthOverride" class="form-control"
                    [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                  </kendo-numerictextbox>
                </div>
                <div class="form-group flex-50">
                  <label>TB Pad Length Override</label>
                  <kendo-numerictextbox formControlName="TBPadLengthOverride" class="form-control"
                    [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                  </kendo-numerictextbox>
                </div>
              </div>
            }
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <input id="IsSimulfrac" class="form-check-input checkbox-parameters" formControlName="IsSimulfrac"
                  type="checkbox">
                <label class="form-check-label" for="IsSimulfrac">Is Simulfrac</label>
              </div>
              <div class="form-group flex-50">
                <input id="OnPadBattery" class="form-check-input checkbox-parameters" formControlName="OnPadBattery"
                  type="checkbox">
                <label class="form-check-label" for="OnPadBattery">On-Pad Battery</label>
              </div>
            </div>
          </div>

          <div class="flex-column flex-align-center" style="padding-bottom:10px">
            <h6 class="card-title">Pit Details</h6>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-33">
                <label>FW Pit Cut Volume (cu yds)</label>
                <kendo-numerictextbox formControlName="FWPitCutVolume" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>FW Pit Liner Area (Sq Ft)</label>
                <kendo-numerictextbox formControlName="FWPitLinerArea" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>Planned Reserve Pit Backfill Type</label>
                <kendo-dropdownlist class="form-control" formControlName="PlannedReservePitBackfillTypeId" [data]="dPlannedReservePitBackfillType"
                  [textField]="'Description'" [valueField]="'PlannedReservePitBackfillTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-33">
                <label>FW Pit Fill Volume (cu yds)</label>
                <kendo-numerictextbox formControlName="FWPitFillVolume" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>FW Pit Perimeter (Ft)</label>
                <kendo-numerictextbox formControlName="FWPitPerimeter" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>Total FW + Reserve Pit Cut Volume (cu yds)</label>
                <kendo-numerictextbox [value]="(padConstructionForm.get('FWPitCutVolume')?.value ?? null) + (padConstructionForm.get('ReservePitCutVolume')?.value ?? null)" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-33">
                <label>Reserve Pit Cut Volume (cu yds)</label>
                <kendo-numerictextbox formControlName="ReservePitCutVolume" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>Reserve Pit Liner Area (Sq Ft)</label>
                <kendo-numerictextbox formControlName="ReservePitLinerArea" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-33">
                <label>Reserve Pit Fill Volume (cu yds)</label>
                <kendo-numerictextbox formControlName="ReservePitFillVolume" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>Reserve Pit Perimeter (ft)</label>
                <kendo-numerictextbox formControlName="ReservePitPerimeter" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-33">
                <label>FW Pit Area (Sq Ft)</label>
                <kendo-numerictextbox formControlName="FWPitArea" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-33">
                <label>Reserve Pit Area (Sq Ft)</label>
                <kendo-numerictextbox formControlName="ReservePitArea" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="flex-50">
          <div class="flex-column flex-align-center" style="padding-bottom:10px">
            <h6 class="card-title">Material & Logistics </h6>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Distance to Rock Quarry</label>
                <kendo-numerictextbox formControlName="DistanceToRockQuarry" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Drill Pad Base Type</label>
                <kendo-dropdownlist class="form-control" formControlName="DrillPadBaseTypeId" [data]="dDrillPadBaseType"
                  [textField]="'Description'" [valueField]="'DrillPadBaseTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Tank Battery Base Type</label>
                <kendo-dropdownlist class="form-control" formControlName="TankBatteryBaseTypeId" [data]="dTankBatteryBaseType"
                  [textField]="'Description'" [valueField]="'TankBatteryBaseTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
              <div class="form-group flex-50">
                <label>Sound Wall Material</label>
                <kendo-dropdownlist class="form-control" formControlName="SoundMaterialTypeId" [data]="dSoundMaterialType"
                  [textField]="'Description'" [valueField]="'SoundMaterialTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Sound Wall Length</label>
                <kendo-numerictextbox formControlName="SoundWallLength" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Sound Wall Height</label>
                <kendo-numerictextbox formControlName="SoundWallHeight" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Sound Wall Duration</label>
                <kendo-numerictextbox formControlName="SoundWallDuration" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Aux Pad Base Type</label>
                <kendo-dropdownlist class="form-control" formControlName="AuxPadBaseTypeId" [data]="dAuxPadBaseType"
                  [textField]="'Description'" [valueField]="'AuxPadBaseTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Cattle Guard / Gates</label>
                <kendo-dropdownlist class="form-control" formControlName="ConstructionFenceTypeId" [data]="dConstructionFenceType"
                  [textField]="'Description'" [valueField]="'ConstructionFenceTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
              <div class="form-group flex-50">
                <label>Line Reroute</label>
                <kendo-dropdownlist class="form-control" formControlName="LineRerouteId" [data]="dLineReroute"
                  [textField]="'Description'" [valueField]="'LineRerouteId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Cellar Box Count</label>
                <kendo-numerictextbox formControlName="CellarBoxCount" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Distance to Disposal</label>
                <kendo-numerictextbox formControlName="DistanceToDisposal" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Pit Liner Mat Count</label>
                <kendo-numerictextbox formControlName="PitLinerMatCount" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Power Utility Poles Rerouted</label>
                <kendo-numerictextbox formControlName="PowerUtilityPolesRerouted" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Culverts Size (in)</label>
                <kendo-numerictextbox formControlName="CulvertsSize" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-50">
                <label>Culverts Length (ft)</label>
                <kendo-numerictextbox formControlName="CulvertsLength" class="form-control"
                  [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Culverts Type</label>
                <kendo-dropdownlist class="form-control" formControlName="CulvertsTypeId" [data]="dCulvertsType"
                  [textField]="'Description'" [valueField]="'CulvertsTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
              <div class="form-group flex-50">
                <input id="IsWaterHauledInForConstruction" class="form-check-input checkbox-parameters" formControlName="IsWaterHauledInForConstruction"
                  type="checkbox">
                <label class="form-check-label" for="IsWaterHauledInForConstruction">Water Hauled in for Construction</label>
              </div>
            </div>
          </div>

          <div class="flex-column flex-align-center" style="padding-bottom:10px">
            <h6 class="card-title">Misc</h6>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px;">
              <div class="form-group flex-50">
                <input id="IsRockContingency" class="form-check-input checkbox-parameters" formControlName="IsRockContingency"
                  type="checkbox">
                <label class="form-check-label" for="IsRockContingency">Rock Contingency</label>
              </div>
              <div class="form-group flex-50">
                <input id="IsEngineering" class="form-check-input checkbox-parameters" formControlName="IsEngineering"
                  type="checkbox">
                <label class="form-check-label" for="IsEngineering">Engineering</label>
              </div>
            </div>
            <!-- For each  Row  -->
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; width:95%; padding-right: 20px; padding-top: 20px;">
              <div class="form-group flex-50">
                <input id="IsEnvironmental" class="form-check-input checkbox-parameters" formControlName="IsEnvironmental"
                  type="checkbox">
                <label class="form-check-label" for="IsEnvironmental">Environmental</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>
<kendo-dialog class="standard-dialog" [hidden]="!showEquationHelp" title="Equation Help" (close)="showEquationHelp = false" [width]="850">
  <div style="padding: 12px 16px;">
    <p>{{equationValue}}</p>
  </div>
</kendo-dialog>